export const setRedrawIndex = (index: number) => {
  if (index < 0) {
    console.error("Redraw index cannot be negative.");
    return 0; // Reset to default if invalid index is provided
  }
  return index;
};
